// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommentFeedFragmentDoc, CommentCurrentUserFragmentDoc } from '../../../components/comments/CommentFeed.generated';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OverviewTabQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type OverviewTabQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, unitCostInCents: number, totalCostInCents: number, totalPriceInCents: number, markupBasisPoints?: number | null | undefined, quantity?: number | null | undefined, costType: Types.CostType, name: string, displayName: string, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, canEditCost: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditName: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditScope: { __typename?: 'PotentialOperation2', allowed: boolean }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean }, bidItem?: { __typename?: 'BidItem', name: string, id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, location: { __typename?: 'Location', id: string, name: string }, project:
      | { __typename?: 'StandaloneProject', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Region', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Market', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Community', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Subdivision', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Lot', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Structure', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      | { __typename?: 'Unit', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    , task?: { __typename?: 'Task', id: string } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> }, locations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type OverviewTabScheduleTasksQueryVariables = Types.Exact<{
  filter: Types.ScheduleTaskFilter;
}>;


export type OverviewTabScheduleTasksQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string }> };

export type OverviewTabSaveProjectItemMutationVariables = Types.Exact<{
  projectItem: Types.ProjectItemInput;
}>;


export type OverviewTabSaveProjectItemMutation = { __typename?: 'Mutation', saveProjectItems: { __typename?: 'SaveProjectItemsResult', projectItems?: Array<{ __typename?: 'ProjectItem', id: string, unitCostInCents: number, totalCostInCents: number, totalPriceInCents: number, markupBasisPoints?: number | null | undefined, quantity?: number | null | undefined, costType: Types.CostType, name: string, displayName: string, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, canEditCost: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditName: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditScope: { __typename?: 'PotentialOperation2', allowed: boolean }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean }, bidItem?: { __typename?: 'BidItem', name: string, id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, location: { __typename?: 'Location', id: string, name: string }, project:
        | { __typename?: 'StandaloneProject', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Region', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Market', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Community', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Subdivision', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Lot', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Structure', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
        | { __typename?: 'Unit', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
      , task?: { __typename?: 'Task', id: string } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> }> | null | undefined, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null | undefined } };

export type OverviewTabDeleteProjectItemMutationVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type OverviewTabDeleteProjectItemMutation = { __typename?: 'Mutation', deleteProjectItem: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type OverviewTab_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, unitCostInCents: number, totalCostInCents: number, totalPriceInCents: number, markupBasisPoints?: number | null | undefined, quantity?: number | null | undefined, costType: Types.CostType, name: string, displayName: string, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, canEditCost: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditName: { __typename?: 'PotentialOperation2', allowed: boolean }, canEditScope: { __typename?: 'PotentialOperation2', allowed: boolean }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean }, bidItem?: { __typename?: 'BidItem', name: string, id: string, displayName: string, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, products: Array<{ __typename?: 'Product', id: string, name: string }> } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, location: { __typename?: 'Location', id: string, name: string }, project:
    | { __typename?: 'StandaloneProject', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Region', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Market', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Community', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Subdivision', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Lot', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Structure', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
    | { __typename?: 'Unit', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }
  , task?: { __typename?: 'Task', id: string } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> };

export type OverviewTab_ProductFragment = { __typename?: 'Product', costInCents?: number | null | undefined, custom: boolean, description?: string | null | undefined, manufacturerUrl?: string | null | undefined, msrpInCents?: number | null | undefined, priceInCents?: number | null | undefined, priceLastUpdated?: Types.Scalars['DateTime']['input'] | null | undefined, sku?: string | null | undefined, upc?: string | null | undefined, specifications?: string | null | undefined, id: string, name: string, attributes: Array<{ __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType }>, images: Array<{ __typename?: 'Asset', id: string, url: string, downloadUrl: string, contentType: string }>, items: Array<{ __typename?: 'Item', id: string, displayName: string, name: string }>, dimensions: Array<{ __typename?: 'ProductDimension', id: string, rawValue: string, dimensionType: { __typename?: 'ProductDimensionTypeDetail', code: Types.ProductDimensionType, name: string } }>, status: { __typename?: 'ProductStatusDetail', code: Types.ProductStatus, name: string }, bidItems: Array<{ __typename?: 'BidItem', id: string, displayName: string }> };

export const OverviewTab_ProjectItemFragmentDoc = gql`
    fragment OverviewTab_ProjectItem on ProjectItem {
  id
  ...CommentFeed
  unitCostInCents
  totalCostInCents
  totalPriceInCents
  markupBasisPoints
  quantity
  unitOfMeasure {
    id
    name
    useQuantity
  }
  canEditCost {
    allowed
  }
  canEditName {
    allowed
  }
  canEditScope {
    allowed
  }
  projectStage {
    id
    hasSignedContract
  }
  bidItem {
    ...DisplayNamed
    name
    costType {
      code
      name
    }
    products {
      id
      name
    }
  }
  item {
    id
    costCode {
      id
      displayName
      division {
        id
        displayName
      }
    }
    tradeCategory {
      id
      name
    }
  }
  costType
  name
  displayName
  location {
    ...Named
  }
  specifications
  tradePartnerNote
  internalNote
  project {
    id
    canEditPrice {
      ...PotentialOperationDetails
    }
  }
  task {
    id
  }
}
    ${CommentFeedFragmentDoc}
${DisplayNamedFragmentDoc}
${NamedFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const OverviewTab_ProductFragmentDoc = gql`
    fragment OverviewTab_Product on Product {
  ...Named
  costInCents
  custom
  description
  manufacturerUrl
  msrpInCents
  priceInCents
  priceLastUpdated
  sku
  upc
  attributes {
    id
    value
    type
  }
  images {
    id
    url
    downloadUrl
    contentType
  }
  items {
    id
    displayName
    name
  }
  specifications
  dimensions {
    id
    dimensionType {
      code
      name
    }
    rawValue
  }
  status {
    code
    name
  }
  bidItems {
    ...DisplayNamed
  }
}
    ${NamedFragmentDoc}
${DisplayNamedFragmentDoc}`;
export const OverviewTabDocument = gql`
    query OverviewTab($projectItemId: ID!) {
  currentInternalUser {
    ...CommentCurrentUser
  }
  projectItem(id: $projectItemId) {
    ...OverviewTab_ProjectItem
  }
  locations {
    ...Named
  }
}
    ${CommentCurrentUserFragmentDoc}
${OverviewTab_ProjectItemFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useOverviewTabQuery__
 *
 * To run a query within a React component, call `useOverviewTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewTabQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useOverviewTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OverviewTabQuery, OverviewTabQueryVariables> & ({ variables: OverviewTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OverviewTabQuery, OverviewTabQueryVariables>(OverviewTabDocument, options);
      }
export function useOverviewTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OverviewTabQuery, OverviewTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OverviewTabQuery, OverviewTabQueryVariables>(OverviewTabDocument, options);
        }
// @ts-ignore
export function useOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabQuery, OverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverviewTabQuery, OverviewTabQueryVariables>;
export function useOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabQuery, OverviewTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverviewTabQuery | undefined, OverviewTabQueryVariables>;
export function useOverviewTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabQuery, OverviewTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OverviewTabQuery, OverviewTabQueryVariables>(OverviewTabDocument, options);
        }
export type OverviewTabQueryHookResult = ReturnType<typeof useOverviewTabQuery>;
export type OverviewTabLazyQueryHookResult = ReturnType<typeof useOverviewTabLazyQuery>;
export type OverviewTabSuspenseQueryHookResult = ReturnType<typeof useOverviewTabSuspenseQuery>;
export type OverviewTabQueryResult = Apollo.QueryResult<OverviewTabQuery, OverviewTabQueryVariables>;
export const OverviewTabScheduleTasksDocument = gql`
    query OverviewTabScheduleTasks($filter: ScheduleTaskFilter!) {
  scheduleTasks(filter: $filter, first: 10000) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useOverviewTabScheduleTasksQuery__
 *
 * To run a query within a React component, call `useOverviewTabScheduleTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewTabScheduleTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewTabScheduleTasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOverviewTabScheduleTasksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables> & ({ variables: OverviewTabScheduleTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>(OverviewTabScheduleTasksDocument, options);
      }
export function useOverviewTabScheduleTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>(OverviewTabScheduleTasksDocument, options);
        }
// @ts-ignore
export function useOverviewTabScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>;
export function useOverviewTabScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverviewTabScheduleTasksQuery | undefined, OverviewTabScheduleTasksQueryVariables>;
export function useOverviewTabScheduleTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>(OverviewTabScheduleTasksDocument, options);
        }
export type OverviewTabScheduleTasksQueryHookResult = ReturnType<typeof useOverviewTabScheduleTasksQuery>;
export type OverviewTabScheduleTasksLazyQueryHookResult = ReturnType<typeof useOverviewTabScheduleTasksLazyQuery>;
export type OverviewTabScheduleTasksSuspenseQueryHookResult = ReturnType<typeof useOverviewTabScheduleTasksSuspenseQuery>;
export type OverviewTabScheduleTasksQueryResult = Apollo.QueryResult<OverviewTabScheduleTasksQuery, OverviewTabScheduleTasksQueryVariables>;
export const OverviewTabSaveProjectItemDocument = gql`
    mutation OverviewTabSaveProjectItem($projectItem: ProjectItemInput!) {
  saveProjectItems(input: {projectItems: [$projectItem]}) {
    projectItems {
      ...OverviewTab_ProjectItem
    }
    userErrors {
      message
    }
  }
}
    ${OverviewTab_ProjectItemFragmentDoc}`;
export type OverviewTabSaveProjectItemMutationFn = Apollo.MutationFunction<OverviewTabSaveProjectItemMutation, OverviewTabSaveProjectItemMutationVariables>;

/**
 * __useOverviewTabSaveProjectItemMutation__
 *
 * To run a mutation, you first call `useOverviewTabSaveProjectItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverviewTabSaveProjectItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overviewTabSaveProjectItemMutation, { data, loading, error }] = useOverviewTabSaveProjectItemMutation({
 *   variables: {
 *      projectItem: // value for 'projectItem'
 *   },
 * });
 */
export function useOverviewTabSaveProjectItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OverviewTabSaveProjectItemMutation, OverviewTabSaveProjectItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OverviewTabSaveProjectItemMutation, OverviewTabSaveProjectItemMutationVariables>(OverviewTabSaveProjectItemDocument, options);
      }
export type OverviewTabSaveProjectItemMutationHookResult = ReturnType<typeof useOverviewTabSaveProjectItemMutation>;
export type OverviewTabSaveProjectItemMutationResult = Apollo.MutationResult<OverviewTabSaveProjectItemMutation>;
export type OverviewTabSaveProjectItemMutationOptions = Apollo.BaseMutationOptions<OverviewTabSaveProjectItemMutation, OverviewTabSaveProjectItemMutationVariables>;
export const OverviewTabDeleteProjectItemDocument = gql`
    mutation OverviewTabDeleteProjectItem($projectItemId: ID!) {
  deleteProjectItem(input: {id: $projectItemId}) {
    emptyResult
  }
}
    `;
export type OverviewTabDeleteProjectItemMutationFn = Apollo.MutationFunction<OverviewTabDeleteProjectItemMutation, OverviewTabDeleteProjectItemMutationVariables>;

/**
 * __useOverviewTabDeleteProjectItemMutation__
 *
 * To run a mutation, you first call `useOverviewTabDeleteProjectItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverviewTabDeleteProjectItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overviewTabDeleteProjectItemMutation, { data, loading, error }] = useOverviewTabDeleteProjectItemMutation({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useOverviewTabDeleteProjectItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OverviewTabDeleteProjectItemMutation, OverviewTabDeleteProjectItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OverviewTabDeleteProjectItemMutation, OverviewTabDeleteProjectItemMutationVariables>(OverviewTabDeleteProjectItemDocument, options);
      }
export type OverviewTabDeleteProjectItemMutationHookResult = ReturnType<typeof useOverviewTabDeleteProjectItemMutation>;
export type OverviewTabDeleteProjectItemMutationResult = Apollo.MutationResult<OverviewTabDeleteProjectItemMutation>;
export type OverviewTabDeleteProjectItemMutationOptions = Apollo.BaseMutationOptions<OverviewTabDeleteProjectItemMutation, OverviewTabDeleteProjectItemMutationVariables>;